import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  MdDashboard, 
  MdPeople, 
  MdRestaurantMenu, 
  MdSchedule, 
  MdMenuBook,
  MdAdd 
} from 'react-icons/md';
import './KitchenDashboard.css';

const KitchenSidebar = ({ active }) => {
  return (
    <div className="kh-sidebar">
      <nav className="kh-nav">
        <NavLink 
          className="kh-nav-brand" 
          to="/kitchen"
        >
          <MdDashboard className="kh-brand-icon" />
          <span className="kh-brand-text">Kitchen Dashboard</span>
        </NavLink>
        
        <NavLink 
          className={({isActive}) => `kh-nav-item ${isActive ? 'active' : ''}`} 
          to="/kitchen/patient-diets"
        >
          <MdPeople className="kh-nav-icon" />
          <span>Patient Diets</span>
        </NavLink>
        
        <NavLink 
          className={({isActive}) => `kh-nav-item ${isActive ? 'active' : ''}`} 
          to="/kitchen/meal-planning"
        >
          <MdRestaurantMenu className="kh-nav-icon" />
          <span>Meal Planning</span>
        </NavLink>
        
        <NavLink 
          className={({isActive}) => `kh-nav-item ${isActive ? 'active' : ''}`} 
          to="/kitchen/daily-schedule"
        >
          <MdSchedule className="kh-nav-icon" />
          <span>Daily Schedule</span>
        </NavLink>
        
        <NavLink 
          className={({isActive}) => `kh-nav-item ${isActive ? 'active' : ''}`} 
          to="/kitchen/manage-menu"
        >
          <MdMenuBook className="kh-nav-icon" />
          <span>Manage Menu</span>
        </NavLink>
        
        <NavLink 
          className={({isActive}) => `kh-nav-item ${isActive ? 'active' : ''}`} 
          to="/kitchen/add-dietplan"
        >
          <MdAdd className="kh-nav-icon" />
          <span>Add Diet Plan</span>
        </NavLink>
      </nav>
    </div>
  );
};

export default KitchenSidebar;